import React, { useState } from "react";
import { Box, Tab, Tabs, Typography, Paper } from "@mui/material";
import IncidentVideos from "./IncidentVideos";
import VisualizationsDashboard from "./VisualizationsDashboard";
import CamerasInformation from "./CamerasInformation";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`shoplifting-tabpanel-${index}`}
      aria-labelledby={`shoplifting-tab-${index}`}
      style={{ minHeight: 'calc(100vh - 200px)' }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, animation: "fadeIn 0.5s ease-in-out" }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `shoplifting-tab-${index}`,
    'aria-controls': `shoplifting-tabpanel-${index}`,
  };
}

const ShopliftingMain = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold' }}>
        Loss Prevention & Shoplifting Analysis
      </Typography>
      
      <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
          <Tabs 
            value={value} 
            onChange={handleChange} 
            aria-label="shoplifting dashboard tabs"
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
            sx={{
              "& .MuiTab-root": {
                fontWeight: 600,
                fontSize: '1rem',
                textTransform: 'none',
                py: 2.5
              }
            }}
          >
            <Tab label="Incident Videos" {...a11yProps(0)} />
            <Tab label="Visualizations" {...a11yProps(1)} />
            <Tab label="Cameras Information" {...a11yProps(2)} />
          </Tabs>
        </Box>
        
        <Box sx={{ bgcolor: 'background.default' }}>
          <CustomTabPanel value={value} index={0}>
            <IncidentVideos />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <VisualizationsDashboard />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <CamerasInformation />
          </CustomTabPanel>
        </Box>
      </Paper>
      
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </Box>
  );
};

export default ShopliftingMain;
